"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const a=require("./index113.js");var s=a.classofRaw,e=Array.isArray||function(r){return s(r)==="Array"};exports.isArray=e;
